import React from "react";
import { PRIMARY, BLACK } from "../styles/color";
import { useThemeColors } from "../Context/Theme";
 
function CustomButton({
  onClick,
  bgcolor,
  text,
  colo,
  borderColor,
  className,
  size,
  block,
  startIcon,
  borderRadius,
  btnStyle,
  width,
  disabled,
}) {
   const {
      primaryColor,
      secondaryColor,
      textColor,
      buttonColor,
      buttonTextColor,
      backgroundColor,
      logo,
      fontWeight, fontSize, fontFamily 
    } = useThemeColors();
 
  const buttonStyle = {
    backgroundColor: bgcolor || buttonColor || PRIMARY,
    color: colo || buttonTextColor || BLACK,
    borderColor: borderColor,
    width: block ? "100%" : "",
    display: "flex",
    alignItems: "center",
    justifyContent: startIcon ? "space-between" : "center",
    padding: "8px 10px",
    borderRadius: borderRadius || "10px",
    ...btnStyle,
    fontWeight: fontWeight || 600,
    fontSize: fontSize || "17px",
    fontFamily,
  };
 
  return (
    <button
      type="button"
      className={`btn btn-lg ${size ? `btn-${size}` : ""} ${
        block ? "w-100" : ""
      }  ${className}`}
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && (
        <img
          src={startIcon}
          height={20}
          alt="Start Icon"
          style={{ marginRight: "10px" }}
        />
      )}
      {text}
    </button>
  );
}
 
export default CustomButton;